
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wordpress-woocommerce-integration",
      function () {
        return require("private-next-pages/wordpress-woocommerce-integration.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wordpress-woocommerce-integration"])
      });
    }
  